import { useCallback } from 'react';
import type { IntegrationAccess } from '@glueapp/graph-types';
import { useIntegrationAccessApi } from '../api/useIntegrationAccessApi';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const useIntegrationAccesses = () => {
    const { getAllIntegrationAccesses, deleteIntegrationAccess: deleteIntegrationAccessApi } = useIntegrationAccessApi();

    const queryResult = useQuery({ queryKey: ['integrationAccesses'], queryFn: getAllIntegrationAccesses, initialData: [] });
    const queryClient = useQueryClient();

    const deleteIntegrationAccess = useCallback(
        (integrationAccess: IntegrationAccess) => {
            async function runFlow() {
                await deleteIntegrationAccessApi(integrationAccess);
                await queryClient.invalidateQueries({ queryKey: ['integrationAccesses'] });
            }
            runFlow();
        },
        [deleteIntegrationAccessApi],
    );

    return {
        integrationAccesses: queryResult.data,
        deleteIntegrationAccess,
    };
};
